import { Alert, AlertDescription, cn } from '@design-system';
import { FlaskConical } from 'lucide-react';

interface SampleClientBannerProps {
  className?: string;
}

export function SampleClientBanner({ className }: SampleClientBannerProps) {
  return (
    <div className={cn('bg-background sticky top-0 z-50 w-full', className)}>
      <Alert
        variant="warning"
        className="flex justify-center rounded-none border-x-0 border-t-0 py-2.5"
      >
        <FlaskConical className="shrink-0" />
        <AlertDescription className="text-xs sm:text-sm">
          You're viewing a sample client. This data is for demonstration purposes only and cannot be
          submitted to carriers or brokers.
        </AlertDescription>
      </Alert>
    </div>
  );
}
